import React from "react"

export type TableProps<TRow> = {
  columns: { key: keyof TRow; label: React.ReactNode }[]
  getRowKey: (row: TRow) => string
  rows: TRow[]
  renderers: Partial<{ [K in keyof TRow]: (row: TRow) => React.ReactNode }>
}

export function Table<TRow>({
  columns,
  rows,
  getRowKey,
  renderers,
}: TableProps<TRow>): JSX.Element {
  return (
    <table>
      <thead>
        <tr>
          {columns.map(({ key, label }) => (
            <th key={String(key)}>{label}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => {
          return (
            <tr key={getRowKey(row)}>
              {columns.map(({ key }) => {
                const fieldRenderer = renderers[key]
                const value = row[key]

                return (
                  <td key={String(key)}>
                    {fieldRenderer
                      ? fieldRenderer(row)
                      : (value as React.ReactNode)}
                  </td>
                )
              })}
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}
